import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=8531b616&scoped=true"
import script from "./SimpleDialog.vue?vue&type=script&lang=ts"
export * from "./SimpleDialog.vue?vue&type=script&lang=ts"
import style0 from "./SimpleDialog.vue?vue&type=style&index=0&id=8531b616&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8531b616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8531b616')) {
      api.createRecord('8531b616', component.options)
    } else {
      api.reload('8531b616', component.options)
    }
    module.hot.accept("./SimpleDialog.vue?vue&type=template&id=8531b616&scoped=true", function () {
      api.rerender('8531b616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/SimpleDialog.vue"
export default component.exports